/**
 * @generated SignedSource<<10f3b7e845c7b014b1e6dfb8d9e85e8a>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ProductTaskState = "CANCELLED" | "COMPLETED" | "ERROR" | "PARTIAL_SUCCESS" | "PROCESSING" | "WAITING";
export type CreateProductTaskRequestInput = {
  assignPricingRules: boolean;
  cloneTemplates?: boolean | null;
  destinationProductIds: ReadonlyArray<number>;
  destinationProducts: ReadonlyArray<DestinationProductDtoInput>;
  salesChannelId?: number | null;
  sourceProductId: number;
};
export type DestinationProductDtoInput = {
  id: number;
  imageUrl?: string | null;
  name?: string | null;
  sku?: string | null;
  statusId?: number | null;
};
export type productDuplicationTaskQueriesCreateMutation$variables = {
  request: CreateProductTaskRequestInput;
};
export type productDuplicationTaskQueriesCreateMutation$data = {
  readonly createProductTask: {
    readonly createdOn: string;
    readonly id: string;
    readonly modifiedOn: string;
    readonly progress: {
      readonly completedOperations: number;
      readonly overallProgress: number;
      readonly totalOperations: number;
    } | null;
    readonly settings: {
      readonly assignPricingRules: boolean;
      readonly cloneTemplates: boolean | null;
      readonly destinationProductIds: ReadonlyArray<string>;
      readonly salesChannelId: number | null;
      readonly sellerID: number;
      readonly sourceProductId: string;
      readonly userID: number | null;
    } | null;
    readonly status: number;
    readonly taskID: number;
    readonly taskState: ProductTaskState;
    readonly type: string;
  };
};
export type productDuplicationTaskQueriesCreateMutation = {
  response: productDuplicationTaskQueriesCreateMutation$data;
  variables: productDuplicationTaskQueriesCreateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "request"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "request",
        "variableName": "request"
      }
    ],
    "concreteType": "ProductTaskDto",
    "kind": "LinkedField",
    "name": "createProductTask",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "taskID",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "type",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "taskState",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "createdOn",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "modifiedOn",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ProductTaskSettingsDto",
        "kind": "LinkedField",
        "name": "settings",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sourceProductId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "destinationProductIds",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "cloneTemplates",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "assignPricingRules",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "salesChannelId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sellerID",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "userID",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ProductTaskProgressDto",
        "kind": "LinkedField",
        "name": "progress",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalOperations",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "completedOperations",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "overallProgress",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "productDuplicationTaskQueriesCreateMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "productDuplicationTaskQueriesCreateMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "c741df86c89e92e269c6533c18c5e2da",
    "id": null,
    "metadata": {},
    "name": "productDuplicationTaskQueriesCreateMutation",
    "operationKind": "mutation",
    "text": "mutation productDuplicationTaskQueriesCreateMutation(\n  $request: CreateProductTaskRequestInput!\n) {\n  createProductTask(request: $request) {\n    id\n    taskID\n    type\n    status\n    taskState\n    createdOn\n    modifiedOn\n    settings {\n      sourceProductId\n      destinationProductIds\n      cloneTemplates\n      assignPricingRules\n      salesChannelId\n      sellerID\n      userID\n    }\n    progress {\n      totalOperations\n      completedOperations\n      overallProgress\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "7d77adc069825ac38ab8f73c865fd4fc";

export default node;
